import React from 'react';
import './CustomerServiceInfo.scss';

const CustomerServiceInfo = () => {
  return (
    <div className="customer-service-container hmf-mt-s hmf-mx-s-s hmf-mx-m-m">
      <div className="hmf-display-flex hmf-flex-column hmf-justify-content-start">
        <span className="customer-service-header hmf-header-bold-xs hmf-mb-xs">
          Customer Service
        </span>
        <span className="hmf-body-m hmf-mb-xs">7 days a week | 8am-5pm ET</span>
        <a href="tel:1-800-440-4002" className="my-account-drawer-link hmf-body-m hmf-mb-xs">
          1-800-440-4002
        </a>
        <span className="hmf-body-m">
          Review our{' '}
          <a
            href="https://www.dickssportinggoods.com/s/scorecard-benefits"
            className="my-account-drawer-link">
            FAQs
          </a>{' '}
          for quick help <br />
          or visit our{' '}
          <a
            href="https://www.dickssportinggoods.com/s/help-desk"
            className="my-account-drawer-link">
            help desk
          </a>
        </span>
      </div>
    </div>
  );
};

export default CustomerServiceInfo;
